import React from "react";
import { useTable, useSortBy } from "react-table";
import { SemDados } from "./Base";
import { Checkbox } from "antd";
import formatarData from "../Utils/formatarData";
import { BtnDeletar, BtnDetalhe, BtnEdit } from "./Buttons";
import useChk from "./Hooks/useChk";
import culture from "../Utils/Culture";
import cultureN0 from "../Utils/CultureN0";

function getAlign(column) {
  if (column.tipo === "rs" || column.tipo === "int" || column.tipo === "dec" || column.tipo === "right") return "right";
  else if (column.tipo === 'center') return "center";

  return "left";
}

function getValue(cell, column) {
  if (column.tipo === "rs" && cell.value != undefined) return `R$ ${culture.format(cell.value)}`;
  else if (column.tipo === "dec" && cell.value != undefined) return culture.format(cell.value);
  else if (column.tipo === "int" && cell.value != undefined) return cultureN0.format(cell.value);
  else if (column.tipo === "dt" && cell.value != undefined) return formatarData(cell.value).DATA;
  else if (column.tipo === "dthr" && cell.value != undefined) return formatarData(cell.value).DATAHORASEGUNDOS;
  else if (column.tipo === "cpfCnpj" && cell.value != undefined) return cell.value.length == 11 ? cell.value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4") : cell.value.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
  return cell.render("Cell");
}

export default function TabelaPadrao(props) {
  if (!props.hideSemDados && (!props.data || !props.data.length)) return <SemDados style={{ marginTop: 50 }} />;
  return <TableDet {...props} />;
}

function TableDet({ columns, data, setEdit, setDetalhe, onDelete, onRowClick, setMarcados, marcados, ghost, showChk, branca, checkOnlyOne, ...rest }) {
  const { getTableProps, getTableBodyProps, headerGroups, footerGroups, rows, prepareRow } = useTable({ columns, data, }, useSortBy);
  const { marcar, indeterminate, allChecked, checkAll } = useChk(marcados, setMarcados, data, checkOnlyOne);
  const hasFooter = React.useMemo(() => columns.filter(x => !!x.Footer).length > 0, [columns]);
  const hasChk = React.useMemo(() => !!setMarcados, [setMarcados]);
  const hasBtns = !!setEdit || !!setDetalhe || !!onDelete;

  return <table className={`tabela-padrao ${ghost ? "headerless" : ""}`} {...rest} {...getTableProps()}>
    <thead>
      {headerGroups.map(headerGroup => (
        <tr {...headerGroup.getHeaderGroupProps()} >
          {(hasChk && !checkOnlyOne) ? <th style={{ textAlign: "left" }}>
            <Checkbox indeterminate={indeterminate} onChange={checkAll} checked={allChecked} />
          </th> : !!hasChk && <th></th>}
          {headerGroup.headers.map((column, inxC) => (
            <th {...column.getHeaderProps(column.getSortByToggleProps())} title="Ordenar" style={{ cursor: "pointer", textAlign: getAlign(columns[inxC]), }}>
              {column.render("Header")}
            </th>
          ))}
          {hasBtns && <th></th>}
        </tr>
      ))}
    </thead>
    <tbody {...getTableBodyProps()}>
      {rows.map((row, i) => {
        prepareRow(row);
        return <Row key={i} hasChk={hasChk} row={row} columns={columns} marcados={marcados} inx={i} marcar={marcar} setEdit={setEdit} setDetalhe={setDetalhe} onRowClick={onRowClick} onDelete={onDelete} hasBtns={hasBtns} />;
      })}
    </tbody>
    <tfoot>
      {hasFooter &&
        footerGroups.map(group => (
          <tr {...group.getFooterGroupProps()}>
            {hasChk && <td></td>}
            {group.headers.map((column, inxC) => <td {...column.getFooterProps()} style={{ textAlign: getAlign(columns[inxC]) }}>
              <span>
                {(columns[inxC].Somar && `R$ ${culture.format(rows.reduce((sum, row) => row.values[columns[inxC].accessor] + sum, 0))}`) || (columns[inxC].SomarQtd && `${culture.format(rows.reduce((sum, row) => row.values[columns[inxC].accessor] + sum, 0))}`) || column.render("Footer")}
              </span>
            </td>
            )}
            {!!hasBtns && <td></td>}
          </tr>
        ))}
    </tfoot>
  </table>;
}

const Row = React.memo(({ hasChk, row, columns, marcados, marcar, setEdit, setDetalhe, onDelete, onRowClick, inx, hasBtns }) => {

  return <tr onClick={() => !!onRowClick && onRowClick(row.original)} {...row.getRowProps()}>
    {hasChk && <td>
      <Checkbox checked={marcados?.includes(row.original.id)} onChange={e => marcar(row.original.id, e.target.checked)} />
    </td>}
    {row.cells.map((cell, inx) => {
      const c = columns[inx];
      return (
        <td {...cell.getCellProps()} style={{ textAlign: getAlign(c) }}>
          {getValue(cell, c)}
        </td>
      );
    })}
    {!!hasBtns && <td className="td-icon" style={{ textAlign: "right" }}>
      {(setDetalhe && !row.original?.disableDetalhe) && <BtnDetalhe small id="icon" onClick={() => setDetalhe(row.original)} />}
      {(setEdit && !row.original?.disableEdit) && <BtnEdit small id="icon" data-cy={'table-btn-edit-' + inx} onClick={() => setEdit(row.original)} />}
      {(onDelete && !row.original?.disableDelete) && <BtnDeletar small id="icon" onOk={() => onDelete(row.original)} />}
    </td>}
  </tr>;
});